import { render, staticRenderFns } from "./node2.vue?vue&type=template&id=70509eb0&"
import script from "./node2.vue?vue&type=script&lang=js&"
export * from "./node2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports